import { createContext } from 'react'
import { TABTestsContext } from './types'

export const ABTestsContext = createContext<TABTestsContext>({

})